import { Div, Span, Collection, Checkbox } from '@tblabs/truffle';
import { SelectableItem } from '../Models/SelectableItem';
import { Swaper } from './Swaper';


export class SelectableListItemBox<T> extends Div
{
    private label = new Span("...").Class("selectable-list-item-label");

    constructor(item: SelectableItem<T>, collection: Collection<SelectableItem<T>>, labelSelector: (item: T) => string, onClick: (self: SelectableItem<T>) => void)
    {
        super("selectable-list-item-box");

        this.label.Text(labelSelector(item.Item))
            .OnClick(() =>
            {
                collection.Find(x => x.IsMarked.value)?.IsMarked?.False();
                item.IsMarked.True();

                onClick(item);
            });

        item.IsMarked.OnChange(isMarked => isMarked ? this.Mark() : this.Unmark(), true);
   
        this.Append(
            new Div().Append(
                new Checkbox(item.IsSelected).MarginLeftRight(8),
                this.label,
            ),
            new Swaper(collection, item).Class("song-item-swaper"),
        );
    }

    public Mark(): void
    {
        this.label.Bold().Color("#61b9d5");
    }

    public Unmark(): void
    {
        this.label.Normal().Color("#ddd");
    }
}
